import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditLocationLayer from "../../components/restaurants/EditLocationLayer";


const EditLocationPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Location" />

        {/* AddUserLayer */}
        <EditLocationLayer />


      </MasterLayout>
    </>
  );
};

export default EditLocationPage;
